export var CONTAINER_CLASS = 'l7plot-tooltip';
export var TITLE_CLASS = 'l7plot-tooltip__title';
export var LIST_CLASS = 'l7plot-tooltip__list';
export var LIST_ITEM_CLASS = 'l7plot-tooltip__list-item';
export var NAME_CLASS = 'l7plot-tooltip__name';
export var VALUE_CLASS = 'l7plot-tooltip__value';
export var CONTAINER_TPL = "<div class=\"".concat(CONTAINER_CLASS, "\">\n  <div class=\"").concat(TITLE_CLASS, "\"></div>\n  <ul class=\"").concat(LIST_CLASS, "\"></ul>\n</div>");
export var ITEM_TPL = "<li class=\"".concat(LIST_ITEM_CLASS, "\" data-index={index}>\n  <span class=\"").concat(NAME_CLASS, "\">{name}</span>\n  <span class=\"").concat(VALUE_CLASS, "\">{value}</span>\n</li>");
//# sourceMappingURL=constants.js.map